import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, concatMap } from 'rxjs/operators';
import {
  AuthAccessTokenDetails,
  LoginOAuthParams,
  OauthAEMConfig,
  RedirectfulResponse
} from '../../../../models/login';
import { LoginRememberMeUtilsService } from '../../../../utils/login';
import { LoggingService } from '../../../utils';
import { LoginRememberMeWrapperService } from '../../wrappers/login-remember-me-wrapper.service';

@Injectable({
  providedIn: 'root'
})
export class AppTokenService {
  private loginRememberMeWrapper = inject(LoginRememberMeWrapperService);
  private loginRememberMeUtils = inject(LoginRememberMeUtilsService);
  private logging = inject(LoggingService);

  tokenValue!: AuthAccessTokenDetails;

  getAppToken(config: OauthAEMConfig): Observable<AuthAccessTokenDetails> {
    if (this.tokenValue) {
      return of(this.tokenValue);
    } else {
      const pkceCode = this.loginRememberMeUtils.generateCodeChallenge();
      const loginOAuthParams: LoginOAuthParams = {
        oauthConfig: config,
        pkceCode: pkceCode
      };
      return this.loginRememberMeWrapper
        .initiatePingFlow(loginOAuthParams, 'INITIATE_LOGIN')
        .pipe(
          concatMap(
            (
              response:
                | AuthAccessTokenDetails
                | RedirectfulResponse
                | boolean
                | string
            ) => {
              if (
                typeof response === 'string' ||
                typeof response === 'boolean'
              ) {
                return of({} as AuthAccessTokenDetails);
              } else if ('access_token' in response) {
                this.tokenValue = response;
                return of(response);
              } else {
                return of({} as AuthAccessTokenDetails);
              }
            }
          ),
          catchError((error) => {
            this.logging.log(error);
            return of({} as AuthAccessTokenDetails);
          })
        );
    }
  }
}
